import { render, staticRenderFns } from "./Progresso.vue?vue&type=template&id=9f61f136&scoped=true"
import script from "./Progresso.vue?vue&type=script&lang=js"
export * from "./Progresso.vue?vue&type=script&lang=js"
import style0 from "./Progresso.vue?vue&type=style&index=0&id=9f61f136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f61f136",
  null
  
)

export default component.exports